module.exports = __webpack_public_path__ + "static/media/usyd.cb78802a.png";